import styled from "@emotion/styled";
import { DateTime } from "luxon";

type Props = {
  startTime: string;
  endTime: string;
};

export const formatSpeakingSlotTime = (time: string) => {
  return DateTime.fromISO(time, { setZone: true }).toFormat('HH:mm');
};

export const BookedSlotTimeIndicator = ({ startTime, endTime }: Props) => (
  <S.Details>
    <S.Line>
      <S.Square />
      <b>Booked</b>
    </S.Line>
    <span>{formatSpeakingSlotTime(startTime)} - {formatSpeakingSlotTime(endTime)}</span>
  </S.Details>
);

const S = {
  Details: styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.2em;
  `,
  Line: styled.div`
    display: flex;
    align-items: center;
    gap: 0.35em;
  `,
  Square: styled.div`
    width: 15px;
    height: 15px;
    border: 2px solid #bf2020;
    background: linear-gradient(to top, #bf2020, #f4a9a5);
  `,
};
